// Every public layout: the hamburger menu, the signed-in header swap
// (lib/session-hint.ts), scroll-to-top on the logo and the hero hearts.
import { bindNavToggle } from '../lib/nav'
import { bindScrollTop } from '../lib/scroll-top'
import { applySessionHint } from '../lib/session-hint'
import { startHearts } from '../lib/hearts'
import { rememberTimeZone } from '../lib/time-zone'

rememberTimeZone()

applySessionHint()

document.querySelectorAll<HTMLButtonElement>('[data-nav-toggle]').forEach(bindNavToggle)
document.querySelectorAll<HTMLAnchorElement>('[data-scroll-top]').forEach((link) => bindScrollTop(link))
document.querySelectorAll<HTMLCanvasElement>('[data-hearts]').forEach((canvas) => startHearts(canvas))

// Close the language menu on outside click or Escape.
document.addEventListener('click', (event) => {
  document.querySelectorAll<HTMLDetailsElement>('.lang-picker[open]').forEach((menu) => {
    if (!menu.contains(event.target as Node)) menu.open = false
  })
})
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll<HTMLDetailsElement>('.lang-picker[open]').forEach((menu) => (menu.open = false))
})
